import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import Button from './Button';
export default function Label(props) {
    const { title, shortTitle, className = '', children, style, description, ...otherProps } = props;
    return (_jsxs("div", { style: { display: 'flex', alignItems: 'center', ...style?.container }, children: [_jsxs("label", { className: className, style: {
                    fontSize: '12px',
                    color: '#232323',
                    paddingRight: '10px',
                    width: 'max-content',
                    ...style?.label,
                }, ...otherProps, children: [_jsx("span", { className: shortTitle ? 'large-label' : '', children: title }), shortTitle && (_jsx("span", { className: "small-label", css: css({ display: 'none' }), children: shortTitle })), description && (_jsx(Button.Info, { toolTip: description, tooltipOrientation: "horizontal", style: { display: 'inline-block' }, backgroundColor: { hover: 'white', base: 'white' }, color: { base: 'gray', hover: 'black' } }))] }), _jsx("div", { style: style?.wrapper, children: children })] }));
}
